import Promise from 'bluebird';
import cache from './index';
import loglevel from 'loglevel';

const log = loglevel.getLogger('fallbackCache');

const EXPIRATION = 86400; // one day

export function getCacheFallback(url) {
    log.warn(`getCacheFallback: ${url}`);
    return Promise
        .fromCallback(cache.get.bind(null, `fallback:${url}`))
        .catch((err) => {
            console.error('Unable to get data from fallback cache');
    });
}

export function setCacheFallback(url, value, expiration = EXPIRATION) {
    if (!!value) {
        cache.set(`fallback:${url}`, value, expiration);
    }
}

const defaultExport = {
    get: getCacheFallback,
    set: setCacheFallback
};

export default defaultExport;



// WEBPACK FOOTER //
// ./app/lib/api/cache/fallbackCache.js